<template>
  <modal
    header-text=""
    :button-text="$t('global.save')"
    @action="$emit('save')"
    @close="$emit('close')"
  >
    <div :class="$style.inputContainer">
      {{ $t('modal.saveChangesForUser') }} {{ name }}?
    </div>
    <template v-slot:footer>
      <button
        :class="$style.button"
        @click="$emit('dontSave')"
      >
        {{ $t('global.doNotSave') }}
      </button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/control-modal.vue';

  export default {
    components: { Modal },
    props: ['control'],
    computed: {
      name() {
        if (this.control) return this.control.name;
        return '';
      },
    },
  };
</script>

<style lang="scss" module>
  .inputContainer {
    font-size: 13px;
    margin: 5px;
  }
  .button {
    height: 30px;
    cursor: pointer;
    margin: 0px 5px;
    background: #2985bf;
    border: 2px solid #2985bf;
    border-radius: 2px;
    font: inherit;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    width: 105px;
  }
</style>
